import { render } from "./RegisterTeamPage.vue?vue&type=template&id=140e4358&scoped=true"
import script from "./RegisterTeamPage.vue?vue&type=script&lang=ts"
export * from "./RegisterTeamPage.vue?vue&type=script&lang=ts"

import "./RegisterTeamPage.vue?vue&type=style&index=0&id=140e4358&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-140e4358"
/* hot reload */
if (module.hot) {
  script.__hmrId = "140e4358"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('140e4358', script)) {
    api.reload('140e4358', script)
  }
  
  module.hot.accept("./RegisterTeamPage.vue?vue&type=template&id=140e4358&scoped=true", () => {
    api.rerender('140e4358', render)
  })

}

script.__file = "src/views/registerTeam/RegisterTeamPage.vue"

export default script